import CreateStakingNetworkBody from './components/createStakingNetworkBody';

const CreateStakingNetworks = () => <CreateStakingNetworkBody />;

export default CreateStakingNetworks;
